module.exports = __webpack_public_path__ + "img/Ju.b1a364d7.png";